import React from 'react';
import { useInView } from 'react-intersection-observer';
import { 
 
  Home as HomeIcon,
  Building,
  Palette,
  Ruler
} from 'lucide-react';
import HeroSlider from '../components/layout/HeroSlider';
import AboutSection from '../components/layout/AboutSection';
import RecentUpdates from '../components/layout/RecentUpdates';
import ExpertTeam from '../components/layout/ExpertTeam';
import TestimonialsSection from '../components/layout/TestimonialsSection';
import SEO from '../components/ui/SEO';
import MaterialsSection from '../components/layout/MaterialsSection';
import ServicesSection from '../components/layout/ServicesSection';
import PortfolioSection from '../components/layout/PortfolioSection';
import ContactSection from '../components/layout/ContactSection';
import SerProducts from '../components/layout/SerProducts';





const Home: React.FC = () => {
  const [heroRef, heroInView] = useInView({ threshold: 0.3, triggerOnce: true });
  const [servicesRef, servicesInView] = useInView({ threshold: 0.2, triggerOnce: true });
  const [statsRef, statsInView] = useInView({ threshold: 0.3, triggerOnce: true });
  const [testimonialsRef, testimonialsInView] = useInView({ threshold: 0.2, triggerOnce: true });

  const services = [
    {
      icon: <HomeIcon className="w-8 h-8" />,
      title: 'VDA Map Approval',
      description: 'Complete VDA map approval services with expert guidance through the entire process.',
      image: '/images/4.jpeg?auto=compress&cs=tinysrgb&w=500'
    },
    {
      icon: <Building className="w-8 h-8" />,
      title: '3D Elevation Design',
      description: 'Stunning 3D elevation designs that bring your architectural vision to life.',
      image: '/images/5.jpeg?auto=compress&cs=tinysrgb&w=500'
    },
    {
      icon: <Palette className="w-8 h-8" />,
      title: 'Interior Design',
      description: 'Creative interior design solutions that maximize space and enhance functionality.',
      image: '/images/10.jpeg?auto=compress&cs=tinysrgb&w=500'
    },
    {
      icon: <Ruler className="w-8 h-8" />,
      title: 'Structural Design',
      description: 'Robust structural design ensuring safety, durability, and code compliance.',
      image: '/images/11.jpeg?auto=compress&cs=tinysrgb&w=500'
    }
  ];

  const stats = [
    { number: '500+', label: 'Projects Completed' },
    { number: '15+', label: 'Years Experience' },
    { number: '300+', label: 'Happy Clients' },
    { number: '50+', label: 'Awards Won' }
  ];

  const testimonials = [
    {
      name: 'Rajesh Kumar',
      role: 'Homeowner',
      content: 'Exceptional service! The team delivered exactly what we envisioned for our dream home. Professional, timely, and creative.',
      rating: 5,
      image: 'https://images.pexels.com/photos/1043471/pexels-photo-1043471.jpeg?auto=compress&cs=tinysrgb&w=150'
    },
    {
      name: 'Priya Sharma',
      role: 'Business Owner',
      content: 'Outstanding architectural design for our office space. They transformed our ideas into a beautiful, functional workplace.',
      rating: 5,
      image: 'https://images.pexels.com/photos/1181686/pexels-photo-1181686.jpeg?auto=compress&cs=tinysrgb&w=150'
    },
    {
      name: 'Amit Patel',
      role: 'Developer',
      content: 'Reliable partner for all our residential projects. Their attention to detail and innovative designs set them apart.',
      rating: 5,
      image: 'https://images.pexels.com/photos/1300402/pexels-photo-1300402.jpeg?auto=compress&cs=tinysrgb&w=150'
    }
  ];

  const portfolioImages = [
    'https://images.pexels.com/photos/106399/pexels-photo-106399.jpeg?auto=compress&cs=tinysrgb&w=600',
    'https://images.pexels.com/photos/1396122/pexels-photo-1396122.jpeg?auto=compress&cs=tinysrgb&w=600',
    'https://images.pexels.com/photos/1643383/pexels-photo-1643383.jpeg?auto=compress&cs=tinysrgb&w=600',
    'https://images.pexels.com/photos/2047940/pexels-photo-2047940.jpeg?auto=compress&cs=tinysrgb&w=600'
  ];

  return (
    <>
      <SEO
        title="Home"
        description="Professional architecture and design services. Transform your vision into stunning reality with our expert team specializing in VDA approvals, 3D elevations, and interior design."
        keywords="architecture, architectural design, design, 2D & 3D interior designers, 2D & 3D design, 3D elevation, interior design, modern interior design, space planning, building design, building planning, residential architecture, commercial architecture, interior designer, construction, construction services, turnkey projects"
      />
     {/* HeroSlider Section */}
     <br/>
      <HeroSlider/>
     {/* HeroSlider Section */}

     {/* AboutSection Section */}
      <AboutSection/>
     {/* AboutSection Section */}

     {/* Services Section */}
     <ServicesSection/>
     {/* Services Section */} 

     {/* Portfolio Section */}
     <PortfolioSection/>
     {/* Portfolio Section */} 

     {/* RecentUpdates Section */}
      <RecentUpdates/>
     {/* RecentUpdates Section */}

     {/* ServiceProduct Section */}
      <SerProducts/>
     {/* ServiceProduct Section */} 

      {/* Expert Teame Section */}
      <ExpertTeam/>

      {/* Expert Teame Section */}

      {/* Testimonials */}
     <TestimonialsSection/>
      {/* Testimonials */}      
    
{/* CTA Section */}
<MaterialsSection/>
{/* CTA Section */}



      {/* Left Side - Enquiry Form */}
      <ContactSection/>
      {/* Left Side - Enquiry Form */}
    </>
  );
};

export default Home;